import {
  areMaterialsValid,
  isRouteComplete
} from "../../../helpers/components/products";

export const BOM_FIELD_IDS = [
  "productWeight",
  "subcategory",
  "components",
  "packaging",
  "route"
];

export const OPTIONAL_BOM_FIELD_IDS = ["electronics", "packagingWeight"];

const isFieldFilled = (value) => {
  if (value === undefined || value === null || value === "") {
    return false;
  }
  if (Array.isArray(value)) {
    return value.length > 0;
  }
  if (typeof value === "object") {
    return Object.keys(value).length > 0;
  }
  return true;
};

const isBomFieldFilled = (field, safeDoc) => {
  if (field === "packaging") {
    return (
      isFieldFilled(safeDoc.packaging) || Number(safeDoc.packagingWeight) === 0
    );
  }
  return isFieldFilled(safeDoc[field]);
};

export const readBomProgress = (productDoc) => {
  const safeDoc = productDoc || {};
  const filledFields = BOM_FIELD_IDS.filter((field) =>
    isBomFieldFilled(field, safeDoc)
  );
  const missingFields = BOM_FIELD_IDS.filter(
    (field) => !isBomFieldFilled(field, safeDoc)
  );
  const percentComplete = BOM_FIELD_IDS.length
    ? filledFields.length / BOM_FIELD_IDS.length
    : 0;
  return { filledFields, missingFields, percentComplete };
};

export const isBomSurveyComplete = ({
  components = [],
  productWeight,
  packaging = [],
  packagingWeight,
  route = {},
  subcategory
}) =>
  areMaterialsValid(components, productWeight) &&
  areMaterialsValid(packaging, packagingWeight) &&
  isRouteComplete(route) &&
  !!subcategory;
